<template>
  <div data-cy="card_cartao_container">
    <v-card
      v-for="(item, index) in lista"
      :key="item.card_id"
      :data-cy="`card_cartao_${index}`"
      class="mt-6 mt-md-8 py-4"
    >
      <v-card-title
        v-if="item.nickname"
        class="body-2 py-0 pr-10 pl-3 text-truncate d-block primary--text text-uppercase"
        :class="$vuetify.breakpoint.mdAndUp ? 'perfil-card-apelido' : ''"
      >
        <strong>{{ item.nickname }}</strong>
      </v-card-title>

      <v-menu
        bottom
        right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            class="mais-opcoes"
            data-cy="btn_mais_acoes"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            :to="`enderecos/editar/${item.id}`"
            data-cy="btn_editar_endereco"
          >
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-show="!item.is_main"
            data-cy="btn_tornar_principal"
            @click="tornarPrincipal(index, item.id)"
          >
            <v-list-item-title>Tornar principal</v-list-item-title>
          </v-list-item>
          <v-list-item
            data-cy="btn_excluir_endereco"
            @click="excluirCard(item.is_main, item.id)"
          >
            <v-list-item-title>Excluir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-card-text class="pt-3 pb-0 pl-3">
        <p class="mb-0">
          {{ item.street }} {{ item.number }}. {{ item.neighborhood }}
        </p>
        <p
          class="mb-0"
          :class="[item.is_main ? '' : 'mb-7']"
        >
          {{ item.city }} - {{ item.state }}
        </p>

        <v-chip
          v-if="item.is_main"
          :class="$vuetify.breakpoint.mdAndUp ? 'perfil-tag-principal' : ''"
          label
          outlined
          color="primary--text mt-1 mt-md-0"
        >
          Principal
        </v-chip>
      </v-card-text>
    </v-card>
    <ModalConfirmacao
      :show-dialog="abrirModalConfirmacao"
      @changeDialog="retornoModalConfirmacao($event)"
    >
      <template slot="titulo">
        Excluir endereço
      </template>
      <template slot="texto">
        Deseja excluir este endereço?
      </template>
      <template slot="btFalse">
        Não
      </template>
      <template slot="btTrue">
        Sim
      </template>
    </ModalConfirmacao>
  </div>
</template>

<script>
import ModalConfirmacao from '@/components/MeuPerfil/ModalConfirmacao.vue';

export default {
  name: 'ListaEnderecos',

  components: {
    ModalConfirmacao,
  },

  props: {
    lista: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      abrirModalConfirmacao: false,
      idEndereco: '',
    };
  },

  methods: {
    excluirCard(principal, id) {
      this.abrirModalConfirmacao = true;
      this.idEndereco = id;
    },

    retornoModalConfirmacao(value) {
      if (value) {
        this.$emit('excluirCard', this.idEndereco);
      }
      this.abrirModalConfirmacao = false;
    },

    tornarPrincipal(index, id) {
      this.$emit('setPrincipal', index, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.mais-opcoes {
  position: absolute;
  right: 5px;
  top: 10px;
}
.perfil-tag-principal {
  position: absolute;
  right: 56px;
  top: 17px
}
.perfil-card-apelido {
  padding-right: 150px !important;
}
</style>
